import React from 'react';
import { Editor } from '@tiptap/react';
import { Variable } from 'lucide-react';

interface EmailVariableButtonsProps {
  editor: Editor;
  variables: string[];
}

const EmailVariableButtons: React.FC<EmailVariableButtonsProps> = ({ editor, variables }) => {
  if (variables.length === 0) return null;

  const insertVariable = (variable: string) => {
    editor.chain().focus().insertContent(variable).run();
  };

  return (
    <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-200 bg-amber-50/50">
      <span className="text-xs font-medium text-gray-500 flex items-center gap-1">
        <Variable size={14} />
        Variables:
      </span>
      <div className="flex flex-wrap gap-1.5">
        {variables.map(v => (
          <button
            key={v}
            type="button"
            onClick={() => insertVariable(v)}
            className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-amber-100 text-amber-800 border border-amber-200 hover:bg-amber-200 transition-colors cursor-pointer"
            title={`Insert ${v} at cursor`}
          >
            {v}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EmailVariableButtons;
